module.exports = __webpack_public_path__ + "img/aeroland-branding-image-11.01572780.png";